export const STORE_BOOK_ADDED_SENT = 'store_book_added_sent';
export const STORE_BOOK_DISABLED = 'store_book_disabled';
export const STORE_BOOK_ENABLED = 'store_book_enabled';
export const STORE_BOOK_FAILED = 'store_book_failed';
export const STORE_BOOK_PENDING = 'store_book_pending';
export const STORE_BOOK_LOADED = 'store_book_loaded';
export const STORE_BOOK_RESET_STATUS = 'store_book_reset_status';
export const STORE_BOOK_SENDING = 'store_book_sending';
export const STORE_BOOK_UPDATED_SENT = 'store_book_updated_sent';
